<template>
  <section class="about-plant content-section">
    <b-container>
      <b-row class="align-items-end">
        <b-col cols="12">
          <div class="content-wrap">
            <h2 class="content-section-title">OUR PLANT</h2>
          </div>
        </b-col>
        <b-col cols="12" class="mt-4">
          <b-row align-h="center">
            <b-col
              class="mb-3"
              cols="12"
              md="4"
              :offset-md="i > 0 ? 1 : 0"
              v-for="(plant, i) in plants"
              :key="i"
            >
              <b-card :img-src="plant.img" img-alt="Image" img-top>
                <template #header>
                  <h4 class="mb-0">{{ plant.name }}</h4>
                </template>
                <b-list-group flush>
                  <b-list-group-item
                    v-for="(desc, key) in plant.desc"
                    :key="key"
                  >
                    {{ desc }}
                  </b-list-group-item>
                </b-list-group>
              </b-card>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
export default {
  data() {
    return {
      plants: [
        {
          name: "UPC Auto Parts CO., LTD.",
          img: require("@/assets/images/about/plant_01.jpg"),
          desc: [
            "Established Year: 2001",
            "Location: Danyang City, Jiangsu, China",
            "Number of Employee: 350",
            "Plant Size: 58,000 Square Meter",
            "Monthly Capacity: 5,000,000/Month",
            "Shipping Port: Shanghai, China",
            "Main Market: Europe, Asia, and Australia",
          ],
        },
        {
          name: "Scan Top Yilan Factory",
          img: require("@/assets/images/about/plant_02.jpg"),
          desc: [
            "Established Year: 2020",
            "Location: Wujie Township, Yilan County, Taiwan",
            "Number of Employee: 80",
            "Plant Size: 8,350 Square Meter",
            "Monthly Capacity: 600,000/Month",
            "Shipping Port: Keelung, Taiwan",
            "Main Market: North America",
          ],
        },
      ],
    };
  },
};
</script>

<style lang="scss">
.about-plant {
  // color: rgba(255,255,255,1);
  position: relative;
  background-size: cover;
  // background-repeat: no-repeat;
  // background-image: url("~@/assets/images/about/plant_bg.jpg");

  // &.content-section{
  //     padding: 30px;
  //     margin-top: 50px;
  //     margin-bottom: 50px;
  // }
  .content-wrap {
    h2 {
      letter-spacing: 1px;
      text-transform: uppercase;
    }
    hr {
      margin: 20px 0;
      background-color: #fff;
      height: 3px;
    }
  }
  .img-wrap {
    width: 100%;
    position: absolute;
    bottom: 30px;
    box-shadow: 12px 12px 0px 0px rgba(192, 211, 233, 1);
  }
  .card-body {
    padding: 0;
  }
}
</style>